import { BrowserRouter } from "react-router-dom";
import "../src/assets/styles/style.css";
import "../src/assets/styles/stylesheet.css";
import "../src/assets/styles/studentstyle.css";
import 'react-toastify/dist/ReactToastify.css';

import AllRoutes from "./Routes/allRoutes";
import { ToastContainer } from "react-toastify";
import { CartProvider } from "./StudentPanel/CartContext";
import { AuthContextProvider } from "./Context/authContext";
import { SidebarProvider } from "./Context/toggleContext";

function App() {
  return (
    <div>
      <AuthContextProvider>
          <SidebarProvider>
            <CartProvider>
              <BrowserRouter>
                <AllRoutes />
                <ToastContainer theme="colored" />
              </BrowserRouter>
            </CartProvider>
          </SidebarProvider>
      </AuthContextProvider>
    </div>
  );
}

export default App;
